<template>
  <div v-if="calc" class="calculator-calculate">
    <div class="calc-summary">
      <div class="calc-summary-item">
        <div class="calc-summary-item-border">
          <img src="/img/calculator/ic_cal.png" alt="Calculator">
          <div>
            {{ getTotalPrice() | formatNumber }}
          </div>
        </div>
      </div>
      <div v-if="calc.hideDscntPcFlag === 'N'" class="calc-summary-item">
        <div class="calc-summary-item-border">
          <img src="/img/calculator/ic_cal.png" alt="Calculator">
          <div>
            {{ getTotalDiscountPrice() | formatNumber }}
          </div>
        </div>
      </div>
      <div v-if="calc.hidePointFlag === 'N'" class="calc-summary-item">
        <div class="calc-summary-item-border">
          <img src="/img/calculator/ic_point.png" alt="Point">
          <div>
            {{ getTotalPoint() | formatNumber }}P
          </div>
        </div>
      </div>
    </div>
    <div class="clear" />

    <div v-if="!shared" class="calculator-options">
      <div class="calculator-option">
        <input-control v-model="calc.hideDscntPcFlag" type="checkbox" :is-switch="false" name="hide_dscnt_pc_flag" :title="$t('calculator.text.hide_discount_price')" />
      </div>
      <div class="calculator-option">
        <input-control v-model="calc.hidePointFlag" type="checkbox" :is-switch="false" name="hide_point_flag" :title="$t('calculator.text.hide_point')" />
      </div>
      <div class="clear" />
    </div>
    <div class="clear" />

    <div class="calculate-info calculate-info-first">
      <div class="selectors">
        <select v-model="calc.sexdstnCode" class="input-control simple-design select-type" name="sex_distinction" :disabled="shared">
          <option value="">
            {{ $t('calculator.placeholder.sex_distinction') }}
          </option>
          <option v-for="(sexdstnCode, sexdstnCodeIndex) in sexdstnCodes" :key="'sex-distinct-code-' + sexdstnCodeIndex" :value="sexdstnCode.codeId">
            {{ $t('code.nm.' + sexdstnCode.codeId) }}
          </option>
        </select>
        <select v-model="calc.ageCode" class="input-control simple-design select-type" name="age_code" :disabled="shared">
          <option value="">
            {{ $t('calculator.placeholder.age') }}
          </option>
          <option v-for="(ageCode, ageCodeIndex) in ageCodes" :key="'age-' + ageCodeIndex" :value="ageCode.codeId">
            {{ $t('code.nm.' + ageCode.codeId) }}
          </option>
        </select>
        <input-control
          v-model="calc.reasonsForInputControl"
          :disabled="shared"
          type="multiselect"
          :no-title="true"
          :title="$t('calculator.placeholder.reset_reason')"
          class="simple-design reset-reason-select select-type"
          :options="reasonOptions"
        />
      </div>
      <div class="clear" />
      <div class="calculate-info-input">
        <input-control
          v-model="calc.nm"
          type="text"
          :no-title="true"
          :placeholder="$t('calculator.text.title_and_info')"
          :disabled="shared"
        />
      </div>

      <div class="clear" />
      <div class="calculate-info-input">
        <input-control
          v-model="calc.shareMent"
          type="textarea"
          :no-title="true"
          :placeholder="$t('calculator.text.share_ment')"
          :disabled="shared"
          :auto-resize="true"
        />
      </div>
    </div>
    <div class="clear" />
    <product-groups
      ref="productGroupsRef"
      :groups="productsGroups"
      :show-selected="showSelected"
      :hide-point-flag="calc.hidePointFlag"
      :shared="shared"
      @updated="onUpdateGroups"
    />
    <div v-if="shared" class="controls share-controls bottom-fixed-controls">
      <div class="button-area">
        <button v-if="calc.likedFlag === 'Y'" class="btn no-border btn-like" @click="like(false, $event)">
          <i class="fa fa-heart" /> {{ calc.likeCo }}
        </button>
        <button v-else class="btn no-border btn-like" @click="like(true, $event)">
          <i class="fa fa-heart-o" /> {{ calc.likeCo }}
        </button>
        <button class="btn no-border" @click="copyCalc($event)">
          {{ $t('common.button.import') }}
        </button>
        <button class="btn no-border" @click="copyUrl($event)">
          {{ $t('calculator.button.copy_url') }}
        </button>
      </div>
    </div>
    <div v-if="!shared" class="controls bottom-fixed-controls">
      <div class="button-area">
        <button class="btn no-border" :disabled="isInitialized()" @click="init($event)">
          {{ $t('calculator.button.reset') }}
        </button>
      </div>
      <div class="button-area">
        <button class="btn no-border" @click="toggleShowSelected($event)">
          <span v-if="showSelected">O</span>
          <span v-else>X</span>
          {{ $t('calculator.button.show_selected') }}
        </button>
      </div>
      <div class="button-area">
        <button class="btn no-border" :disabled="!requiredSatisfied(true)" @click="saveCalcConfirm($event)">
          {{ $t('calculator.button.save') }}
        </button>
      </div>
      <div class="button-area">
        <button class="btn no-border" :disabled="!calc.id" @click="deleteCalcConfirm($event)">
          {{ $t('calculator.button.delete') }}
        </button>
      </div>
      <div class="button-area">
        <button v-if="calc.shareFlag === 'Y'" class="btn no-border" :disabled="!requiredSatisfied()" @click="unshareCalcConfirm($event)">
          {{ $t('calculator.button.cancel_share') }}
        </button>
        <button v-else class="btn no-border" :disabled="!requiredSatisfied()" @click="shareCalcConfirm($event)">
          {{ $t('calculator.button.share') }}
        </button>
      </div>
      <div class="button-area">
        <button class="btn btn-highlighted no-border" :disabled="!requiredSatisfied()" @click="sendConfirm($event)">
          {{ $t('calculator.button.send') }}
        </button>
      </div>
    </div>

    <b-modal
      id="save-confirm-modal"
      ref="saveConfirmModalRef"
      modal-class="simple-design"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="saveCalc($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.save_confirm')" />
    </b-modal>
    <b-modal
      id="delete-confirm-modal"
      ref="deleteConfirmModalRef"
      modal-class="simple-design"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="deleteCalc($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
    <b-modal
      id="share-confirm-modal"
      ref="shareConfirmModalRef"
      modal-class="simple-design"
      :title="$t('calculator.text.share_ment')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="false"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="shareCalc('Y', $event)"
    >
      <input-control
        ref="shareMentOnModalRef"
        v-model="calc.shareMent"
        type="textarea"
        class="share-ment"
        :no-title="true"
        placeholder=" "
        :auto-resize="true"
      />
    </b-modal>

    <b-modal
      id="unshare-confirm-modal"
      ref="unshareConfirmModalRef"
      modal-class="simple-design"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="shareCalc('N', $event)"
    >
      <p class="my-4" v-html="$t('calculator.modal.text.cancel_sharing_confirm')" />
    </b-modal>
  </div>
</template>

<script>
import ProductGroups from './ProductGroups'
export default {
  components: { ProductGroups },
  props: {
    id: {
      type: { Number, String },
      default: undefined
    },
    initCalc: {
      type: Object,
      default: undefined
    },
    shared: {
      type: Boolean,
      default: false
    },
    initShowSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      calc: undefined,
      initCalculation: {
        hideDscntPcFlag: 'N',
        hidePointFlag: 'N',
        sexdstnCode: '',
        ageCode: '',
        nm: '',
        shareMent: '',
        reasons: []
      },
      showSelected: false,
      sexdstnCodes: [],
      resetReasonCodes: [],
      reasonOptions: [],
      ageCodes: [],
      productsGroups: []
    }
  },
  watch: {
    calc: {
      handler(newVal, oldVal) {
        this.$emit('calc-updated', this.calc)
      },
      deep: true
    },
    productsGroups: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.updateCalcProducts()
          if (this.calc) {
            this.calc.productsGroups = newVal
          }
          this.$forceUpdate()
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    this.showSelected = this.initShowSelected
    if (this.initCalc) {
      this.calc = this.initCalc
    }
    let productsGroups
    if (this.calc) {
      productsGroups = this.calc.productsGroups
    }
    if (!productsGroups) {
      const res = await this.$axios.$get('/prduct/public/products', {
        no_loading: true
      })
      productsGroups = res.data
    }
    if (productsGroups) {
      for (let i = 0; i < productsGroups.length; i++) {
        this.productsGroups.push(productsGroups[i])
      }
    }
    this.ageCodes = await this.getCodes('age')
    this.sexdstnCodes = await this.getCodes('sex_distinction')
    this.resetReasonCodes = await this.getCodes('reset_reason')
    for (let i = 0; i < this.resetReasonCodes.length; i++) {
      const code = this.resetReasonCodes[i]
      this.reasonOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }

    if (this.initCalc) {
      if (this.calc.products) {
        this.countProductsFrom(this.calc.products, 'id')
      }
    } else if (!this.id) {
      this.init()
    } else {
      const res = await this.$axios.$get('/calc/calc?id=' + this.id, {
        no_loading: true
      })
      this.calc = res.data
      this.updateCalcForInputControl()
    }
  },
  methods: {
    onUpdateGroups(param) {
      this.productsGroups = param
      this.$forceUpdate()
    },
    sendConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!this.calc.id) {
        this.$toast.error(this.$t('calculator.notification.save_first'))
        return
      }
      const url = this.getSharedUrl()
      if (
        window.getOsType() === 'os_type.android' &&
        window.app &&
        window.app.startActivityWithExtra
      ) {
        const params = {
          'android.intent.extra.SUBJECT': this.calc.nm,
          'android.intent.extra.TEXT': url
        }

        window.app.startActivityWithExtra(
          'android.intent.action.SEND',
          JSON.stringify(params),
          'text/plain',
          this.$t('calculator.button.share')
        )
      } else if (window.getOsType() === 'os_type.ios') {
        const params = {
          subject: this.calc.nm,
          text: url
        }
        if (window.app && window.app.shareText) {
          window.app.shareText(JSON.stringify(params))
        } else {
          this.$toast.error(this.$t('common.notification.upgrade_ios'))
          window.app.openBrowser(
            'https://itunes.apple.com/us/app/keynote/id6444147949?mt=8'
          )
        }
      }
    },
    getSharedUrl() {
      return (
        window.location.protocol +
        '//' +
        window.location.host +
        '/calc?tid=' +
        this.calc.tmpId
      )
    },
    shareCalcConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('shareConfirmModalRef')
      setTimeout(() => {
        this.$refs.shareMentOnModalRef.resizeTextarea()
      }, 400)
    },
    unshareCalcConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('unshareConfirmModalRef')
    },
    saveCalcConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('saveConfirmModalRef')
    },
    updateCalcForInputControl() {
      if (this.calc && this.calc.reasons && this.calc.reasons.length > 0) {
        const reasons = []
        for (let i = 0; i < this.calc.reasons.length; i++) {
          const reason = this.calc.reasons[i]
          reasons.push({
            text: this.$t('code.nm.' + reason.resetResnCode),
            value: reason.resetResnCode
          })
        }
        this.calc.reasonsForInputControl = reasons
      }
      this.initProductCount()
      if (
        this.calc &&
        this.calc.calcProducts &&
        this.calc.calcProducts.length > 0
      ) {
        this.countProductsFrom(this.calc.calcProducts, 'prductId')
      }
    },
    countProductsFrom(list, key) {
      if (!this.productsGroups) {
        return 0
      }
      for (let i = 0; i < list.length; i++) {
        const calcProduct = list[i]
        if (!calcProduct.co) {
          continue
        }
        let found = false
        for (let j = 0; j < this.productsGroups.length; j++) {
          const grp = this.productsGroups[j]
          for (let k = 0; k < grp.data.length; k++) {
            const product = grp.data[k]
            if (product.id === calcProduct[key]) {
              found = true
              product.co = calcProduct.co
              break
            }
          }
          if (found) {
            break
          }
        }
      }
    },
    shareCalc(shareFlag, e) {
      this.calc.shareFlag = shareFlag
      this.saveCalc(e)
    },
    updateCalcProducts() {
      if (!this.calc) {
        return
      }
      if (!this.productsGroups) {
        return
      }
      const products = []
      for (let i = 0; i < this.productsGroups.length; i++) {
        const productList = this.productsGroups[i].data
        for (let j = 0; j < productList.length; j++) {
          const product = productList[j]
          if (product.co > 0) {
            products.push(product)
          }
        }
      }
      this.calc.products = products
      this.$emit('calc-updated', this.calc)
    },
    like(liked, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.$axios
        .$get(
          '/calc/like?likeFlag=' + (liked ? 'Y' : 'N') + '&id=' + this.calc.id
        )
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message))
            if (liked) {
              this.calc.likedFlag = 'Y'
              this.calc.likeCo++
            } else {
              this.calc.likedFlag = 'N'
              this.calc.likeCo--
            }
            this.$forceUpdate()
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
    },
    copyUrl(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.copyToClipboard(this.getSharedUrl())
      this.$toast.info(this.$t('calculator.notification.copied'))
    },
    copyCalc(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      const param = window.copyObject(this.calc)
      delete param.id
      delete param.calcProducts
      delete param.reasons
      param.shareFlag = 'N'
      param.user = this.loggedInUser
      param.productsGroups = this.productsGroups
      this.$emit('copy-calc', param)
    },
    saveCalc(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.updateCalcProducts()
      this.$axios.$post('/calc/calc', this.calc).then(response => {
        if (response.resultCode === 'success') {
          this.hideModal('saveConfirmModalRef')
          this.hideModal('shareConfirmModalRef')
          this.hideModal('unshareConfirmModalRef')
          this.$toast.info(this.$t(response.message))
          this.calc = response.data
          this.updateCalcForInputControl()
          this.$emit('calc-updated', this.calc)
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    deleteCalcConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('deleteConfirmModalRef')
    },
    deleteCalc(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!this.calc.id) {
        this.init()
        return
      }
      this.$axios.$delete('/calc/calc?id=' + this.calc.id).then(response => {
        if (response.resultCode === 'success') {
          this.hideModal('deleteConfirmModalRef')
          this.$toast.info(this.$t(response.message))
          this.$emit('calc-deleted', this.calc)
          this.init()
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    requiredSatisfied(onlySave) {
      if (!onlySave) {
        if (
          !this.calc.sexdstnCode ||
          !this.calc.ageCode ||
          !this.calc.reasonsForInputControl ||
          this.calc.reasonsForInputControl.length === 0
        ) {
          return false
        }
      }
      if (!this.calc.nm) {
        return false
      }
      return this.getSelectedCount() > 0
    },
    getSelectedCount() {
      if (!this.productsGroups) {
        return 0
      }
      let co = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        co += this.getSelectedCountInGroup(grp.data)
      }
      return co
    },
    getSelectedCountInGroup(data) {
      if (!data || data.length === 0) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < data.length; i++) {
        const datum = data[i]
        if (datum.co) {
          ret += datum.co
        }
      }
      return ret
    },
    toggleShowSelected(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showSelected = !this.showSelected
      this.$forceUpdate()
    },
    isInitialized() {
      const ret = window.isObjectEquals(this.calc, this.initCalculation)
      if (ret === false) {
        return false
      }
      return this.getSelectedCount() === 0
    },
    init(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.calc = window.copyObject(this.initCalculation)
      this.initProductCount()
    },
    initProductCount() {
      if (!this.productsGroups) {
        return
      }
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          product.co = 0
        }
      }
      if (this.$refs.productGroupsRef) {
        this.$refs.productGroupsRef.updateCounts(this.productsGroups)
      }
      this.$forceUpdate()
    },
    getTotalPrice() {
      if (!this.productsGroups) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (!product.co) {
            product.co = 0
          }
          ret += product.pc * product.co
        }
      }
      return ret
    },
    getTotalDiscountPrice() {
      if (!this.productsGroups) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (!product.co) {
            product.co = 0
          }
          ret += product.dscntPc * product.co
        }
      }
      return ret
    },
    getTotalPoint() {
      if (!this.productsGroups) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (!product.co) {
            product.co = 0
          }
          ret += product.point * product.co
        }
      }
      return ret
    }
  }
}
</script>

<style scoped>
.calculator-options {
  background-color: white;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 0.358rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.calculate-info {
  background: white;
  border-radius: 0.5rem;
  padding: 0.83333rem 1.2rem;
  margin-bottom: 0.358rem;
}
>>> .custom-control-label {
  line-height: 1.37rem;
}
.calculator-option >>> label {
  font-weight: normal;
}
.calculator-option {
  font-size: 0.825rem;
  color: #343434;
  width: 50%;
}
.calculator-option:nth-child(2) {
  display: flex;
  justify-content: end;
  margin-right: 0.5rem;
}
.selectors {
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.selectors > select {
  margin-right: 0.4rem;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.reset-reason-select {
  width: calc(100% - 11.33rem);
  margin-right: 0 !important;
}
.calculate-info-input {
  width: 100%;
  font-size: 0.83333rem;
  padding: 0.7rem 0;
}
.calculate-info-input >>> textarea {
  min-height: 6rem;
}
.calculate-info-input >>> input,
.calculate-info-input >>> textarea {
  padding: 0.7333rem;
  width: 100%;
  border-radius: 0.14166rem;
  border: 1px solid #bebebe;
}

.calc-summary {
  display: flex;
  align-items: center;
  color: white;
  padding: 0.8333rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 8rem;
  width: 100%;
  background: #360ea6;
  z-index: 10;
  height: 3.25rem;
}
.calc-summary img {
  height: 0.98rem;
}
.calc-summary-item {
  width: calc(100% / 3);
  font-size: 1.133333333333333rem;
  padding: 0.1rem 0;
}
.calc-summary-item img {
  height: 1rem;
  margin-right: 1rem;
}
.calc-summary-item {
  display: flex;
  justify-content: center;
}
.calc-summary-item:first-child {
  padding-left: 0;
  display: flex;
  justify-content: start;
}
.calc-summary-item:last-child {
  padding-right: 0;
  display: flex;
  justify-content: end;
}
.calc-summary-item-border {
  border: none;
  border-radius: 0.275rem;
  padding: 0.39rem;
  width: 7.483rem;
  display: flex;
  align-items: center;
}
.calc-summary-item-border > div {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
}
.controls {
  position: fixed;
  left: 0;
  bottom: 4rem;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100vw;
  justify-content: space-between;
  padding: 1.3166rem 1.5rem;
  background: white;
}
.controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.558rem;
  font-size: 0.883rem;
  height: 2.358rem;
  padding-top: 0.2rem !important;
  padding-bottom: 0 !important;
}
.plus.shared,
.minus.shared {
  color: gray;
}
.btn.btn-like {
  background: #28c8ea;
}
.controls.share-controls {
  justify-content: center;
}
.controls.share-controls .btn {
  width: 6.7333rem;
}
.fa-heart,
.fa-heart-o {
  font-size: 1.1rem;
  margin-right: 0.3rem;
}
.calculator-calculate {
  padding-bottom: 5rem;
  background: white;
}
</style>
